import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the promotional codes filter view.
 * @extends JetView
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the layout of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the filter form
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    type: 'number',
                    label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Permission check
                    css: 'prm-filterByUser',
                    labelPosition: 'top',
                    placeholder: _('ID Usuario'),
                },
                {
                    view: 'text',
                    name: 'LinkId',
                    label: _('LinkId'),
                    labelPosition: 'top',
                    placeholder: _('LinkId'),
                },
            ],
        };

        // Center left section of the filter form
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Name',
                    label: "<span class='icon-user'></span>" + _('Nombre'),
                    labelPosition: 'top',
                    placeholder: _('Nombre'),
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Permission check
                    css: 'prm-filterByUser',
                },
                {
                    view: 'text',
                    name: 'Code',
                    label: _('Código'),
                    labelPosition: 'top',
                    placeholder: _('Código'),
                },
            ],
        };

        // Center right section of the filter form
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Login',
                    label: _('Login'),
                    labelPosition: 'top',
                    placeholder: _('Login'),
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Permission check
                    css: 'prm-filterByUser',
                },
                {
                    view: 'text',
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
                {
                    view: 'datepicker',
                    name: 'Date',
                    id: 'Date',
                    stringResult: true,
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: moment().format('YYYY-MM-DD'), // Default date value
                    format: '%d %M %Y',
                    suggest: {
                        type: 'calendar',
                        body: {
                            maxDate: new Date(), // Limit date selection to today
                        },
                    },
                },
            ],
        };

        // Right section of the filter form
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'IsActivate',
                    label: "<span class='icon-state'></span>" + _('Estado'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: '',
                    options: [
                        { id: '0', value: _('Todos') },
                        { id: 'A', value: _('Activo') },
                        { id: 'I', value: _('Inactivo') },
                    ],
                },
            ],
        };

        // Upper section containing the filter inputs
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir Código'),
                    hidden: !devConfig.getPermAction('betShopReportsPromotionalCodesAdd', 'Add'), // Permission check
                    css: 'prm-betShopReportsPromotionalCodesAdd',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        this.app.callEvent('addCode:button', [{}]); // Trigger add code event
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form inputs
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if applicable
                            }
                        }
                        this.app.callEvent('promotionalCodes:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };

        // Accordion section for filters
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date field
                $$('Datepicker').show(); // Show Datepicker field
            } else {
                if (true) {
                    $$('Date').show(); // Show Date field
                    $$('Datepicker').hide(); // Hide Datepicker field
                }
            }
        });

        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
